import { put, call, takeLatest, select } from 'redux-saga/effects';

import { getRecruiters } from 'services/team';
import { AsyncAction } from 'types/Action';
import { GetRecruiterMeta, GetRecruiterPayload } from 'types/store/GetRecruiters';
import { Store } from 'types/store/Store';

import { getRecruiterActions } from '../actions';

function* getRecruitersRequest(action: AsyncAction<GetRecruiterMeta, GetRecruiterPayload>): any {
  const state: Store = yield select();
  if (state.auth.token) {
    try {
      const { data } = yield call(getRecruiters, action.meta, state.auth.token);
      yield put(getRecruiterActions.success(data));
    } catch (e: any) {
      yield put(getRecruiterActions.failed(e.message));
    }
  }
}


function* getRecruitersWatcher(): any {
  yield takeLatest(getRecruiterActions.REQUEST, getRecruitersRequest);
}

export default getRecruitersWatcher;
